export const CAPTAIN = 'aanvoerders';
export const DEPARTMENTS = 'departments';
export const TYPING_EVENT_DURATION = 12000;
